// extracted by mini-css-extract-plugin
export default {"cardHeader":"subscriptionStyles_cardHeader__3KF7U","cardHeaderTitle":"subscriptionStyles_cardHeaderTitle__JvkP6"};